import {Button, Modal} from "rsuite";
import React from "react";

const RebootConfirmationModal = ({ show, onHide, onConfirm }) => {
  return (
    <Modal open={show} onClose={onHide} backdrop="static" size="xs">
      <Modal.Header>
        <Modal.Title>Подтверждение перезапуска</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Вы уверены, что хотите перезапустить устройство?
        Устройство будет временно недоступно во время перезагрузки.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} appearance="subtle">
          Отмена
        </Button>
        <Button onClick={onConfirm} appearance="primary" color="blue">
          Перезапустить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RebootConfirmationModal;
